export default __webpack_public_path__ + "static/media/board-member_placeholder_dark.52ed7430.png";